'use client';

import Navbar from '@/components/Navbar';
import Footer from '@/components/Footer';
import WhatsAppFloat from '@/components/WhatsAppFloat';

import {
  ArrowRight,
  ArrowUpRight,
  CheckCircle2,
  ChevronDown,
  Clock3,
  MapPin,
  Plane,
  ShieldCheck,
  Users,
  BriefcaseBusiness,
  CarFront,
  Route,
  MessageCircle,
  Settings2, // BARU: icon transmisi
  Fuel, // BARU: icon bahan bakar
  Star, // BARU: icon tag fitur
} from 'lucide-react';

const WA_NUMBER = '6287786556067';

function createWhatsAppUrl(vehicle = '', service = '') {
  const message = `Halo NAYVERA INDO TRANSPORT

Saya ingin menanyakan informasi sewa mobil Depok.

DATA PEMESANAN

Kendaraan: ${vehicle || 'Mohon rekomendasi kendaraan'}
Jenis sewa: ${service || 'Dengan Driver / Lepas Kunci'}
Tanggal mulai:
Jam mulai:
Tanggal selesai:
Lokasi penjemputan:
Tujuan / rute:
Jumlah penumpang:

Mohon informasi ketersediaan unit, harga, pilihan paket, fasilitas, persyaratan, dan biaya tambahan jika ada.

Terima kasih.`;

  return `https://wa.me/${WA_NUMBER}?text=${encodeURIComponent(message)}`;
}

// CATATAN: field lama tetap utuh. Field BARU (transmission, fuel, features, badge)
// hanya perkiraan, silakan sesuaikan dengan spesifikasi unit aslimu.
const fleet = [
  {
    name: 'Toyota Agya / Daihatsu Ayla',
    category: 'CITY CAR',
    capacity: '4–5 penumpang',
    image: '/assets/images/AYLA DAN AGYA.jpg',
    price: 'Rp298.000',
    duration: '12 jam',
    service: 'Lepas Kunci',
    description:
      'Praktis untuk aktivitas harian, kebutuhan kampus, dan perjalanan dalam kota.',
    // BARU
    transmission: 'Manual / Matic',
    fuel: 'Bensin',
    features: ['AC', 'Audio', 'Power Window'],
    badge: '',
  },
  {
    name: 'Toyota Avanza',
    category: 'FAMILY MPV',
    capacity: '6–7 penumpang',
    image: '/assets/images/Avanza.jpeg',
    price: 'Rp598.000',
    duration: 'Per tanggal',
    service: 'Lepas Kunci',
    description:
      'Pilihan untuk perjalanan keluarga, mobilitas bersama, dan aktivitas sehari-hari.',
    // BARU
    transmission: 'Manual / Matic',
    fuel: 'Bensin',
    features: ['AC Double Blower', 'Audio', 'Captain Seat'],
    badge: '',
  },
  {
    name: 'Toyota Innova Reborn',
    category: 'EXECUTIVE MPV',
    capacity: '6–7 penumpang',
    image: '/assets/images/REBORN.jpeg',
    price: 'Rp750.000',
    duration: '12 jam',
    service: 'Lepas Kunci',
    description:
      'Kabin lega untuk perjalanan keluarga, agenda pekerjaan, maupun perjalanan antarkota.',
    // BARU
    transmission: 'Matic',
    fuel: 'Diesel',
    features: ['AC Double Blower', 'Audio', 'Captain Seat'],
    badge: '',
  },
  {
    name: 'Toyota Innova Zenix G',
    category: 'MODERN MPV',
    capacity: '6–7 penumpang',
    image: '/assets/images/ZENIX G.webp',
    price: 'Rp850.000',
    duration: '12 jam',
    service: 'Lepas Kunci',
    description:
      'MPV modern untuk kebutuhan perjalanan yang mengutamakan kenyamanan.',
    // BARU
    transmission: 'Matic',
    fuel: 'Hybrid',
    features: ['AC Double Blower', 'Captain Seat', 'Smart Entry', 'Sunroof'],
    badge: '',
  },
  {
    name: 'Toyota Fortuner',
    category: 'PREMIUM SUV',
    capacity: '6–7 penumpang',
    image: '/assets/images/Fortuner.jpeg',
    price: 'Rp1.700.000',
    duration: '12 jam',
    service: 'Dengan Driver',
    description:
      'SUV premium untuk perjalanan bisnis, acara khusus, dan kebutuhan perjalanan eksklusif.',
    // BARU
    transmission: 'Matic',
    fuel: 'Diesel',
    features: ['AC Multi Zone', 'Leather Seat', 'Sunroof', 'Audio Premium'],
    badge: 'Premium',
  },
  {
    name: 'Toyota Hiace Premio',
    category: 'PREMIUM VAN',
    capacity: '12 penumpang',
    image: '/assets/images/Hiace-Premio.jpeg',
    price: 'Rp1.850.000',
    duration: '12 jam',
    service: 'Dengan Driver',
    description:
      'Pilihan untuk perjalanan rombongan, wisata keluarga, dan kegiatan perusahaan.',
    // BARU
    transmission: 'Manual',
    fuel: 'Diesel',
    features: ['AC Plafon', 'Reclining Seat', 'Audio', 'USB Charger'],
    badge: 'Premium',
  },
];

const services = [
  {
    number: '01',
    icon: CarFront,
    title: 'Sewa Mobil Lepas Kunci',
    description:
      'Untuk kamu yang membutuhkan fleksibilitas berkendara sendiri. Pilihan unit dan persyaratan mengikuti ketentuan yang berlaku.',
  },
  {
    number: '02',
    icon: Users,
    title: 'Sewa Mobil dengan Driver',
    description:
      'Pilihan praktis untuk perjalanan keluarga, aktivitas bisnis, kunjungan kerja, dan kebutuhan perjalanan lainnya.',
  },
  {
    number: '03',
    icon: Plane,
    title: 'Antar Jemput Bandara',
    description:
      'Konsultasikan perjalanan dari Depok menuju atau dari Bandara Soekarno-Hatta sesuai jadwal dan jumlah penumpang.',
  },
  {
    number: '04',
    icon: BriefcaseBusiness,
    title: 'Transportasi Perusahaan',
    description:
      'Dukungan transportasi untuk meeting, kunjungan bisnis, perjalanan dinas, dan agenda perusahaan.',
  },
];

const areas = [
  'Beji',
  'Pancoran Mas',
  'Cimanggis',
  'Sukmajaya',
  'Tapos',
  'Sawangan',
  'Cinere',
  'Limo',
  'Margonda',
  'UI Depok',
  'Depok Lama',
  'Depok Timur',
];

const faqs = [
  {
    question: 'Berapa harga sewa mobil Depok di NAYVERA?',
    answer:
      'Harga bergantung pada jenis kendaraan, durasi, pilihan layanan, rute, dan tanggal pemakaian. Harga yang tercantum di katalog merupakan referensi dan perlu dikonfirmasi kepada admin sebelum booking.',
  },
  {
    question: 'Apakah tersedia rental mobil Depok lepas kunci?',
    answer:
      'Tersedia untuk unit tertentu sesuai ketersediaan dan persyaratan yang berlaku. Silakan hubungi admin untuk mengetahui pilihan kendaraan pada tanggal yang kamu butuhkan.',
  },
  {
    question: 'Apakah tersedia sewa mobil Depok dengan driver?',
    answer:
      'Ya, terdapat pilihan layanan dengan driver untuk kebutuhan tertentu. Sampaikan rute, durasi, dan jumlah penumpang agar admin dapat membantu memberikan informasi yang sesuai.',
  },
  {
    question: 'Apakah NAYVERA melayani perjalanan ke Bandara Soekarno-Hatta?',
    answer:
      'Kamu dapat mengonsultasikan perjalanan menuju atau dari Bandara Soekarno-Hatta. Informasikan lokasi jemput, jadwal penerbangan, jumlah penumpang, dan kebutuhan bagasi.',
  },
  {
    question: 'Apakah mobil dapat digunakan untuk perjalanan luar kota?',
    answer:
      'Perjalanan luar kota dapat dikonsultasikan berdasarkan rute, durasi, kendaraan, dan jenis layanan. Harga serta ketentuan perlu dikonfirmasi sebelum pemesanan.',
  },
  {
    question: 'Bagaimana cara booking rental mobil Depok?',
    answer:
      'Hubungi admin melalui WhatsApp. Sampaikan kendaraan, tanggal, jam, lokasi penjemputan, tujuan, jumlah penumpang, dan jenis layanan. Pastikan ketersediaan serta harga akhir sebelum mengonfirmasi booking.',
  },
];

const articles = [
  {
    number: '01',
    title: 'Kapan sebaiknya menyewa mobil di Depok?',
    paragraphs: [
      'Sewa mobil dapat menjadi pilihan ketika kamu membutuhkan kendaraan untuk agenda keluarga, aktivitas pekerjaan, kunjungan ke kampus, acara khusus, atau perjalanan bersama beberapa orang. Pemilihan kendaraan sebaiknya disesuaikan dengan jumlah penumpang, barang bawaan, dan tujuan perjalanan.',
      'Sebelum memesan, tentukan tanggal penggunaan, perkiraan durasi, titik penjemputan, serta rute perjalanan. Informasi tersebut membantu admin memeriksa ketersediaan kendaraan dan menjelaskan paket yang sesuai.',
    ],
  },
  {
    number: '02',
    title: 'Memilih sewa mobil lepas kunci atau dengan driver',
    paragraphs: [
      'Layanan lepas kunci bisa dipertimbangkan jika kamu ingin mengatur perjalanan secara mandiri dan memenuhi persyaratan penyewaan. Pastikan memahami ketentuan penggunaan, durasi, pengembalian kendaraan, dan dokumen yang diperlukan sebelum menyetujui pemesanan.',
      'Sementara itu, layanan dengan driver dapat menjadi pilihan untuk perjalanan bisnis, kunjungan keluarga, atau rute yang belum kamu kenal. Tanyakan apakah paket mencakup biaya operasional tertentu dan apakah ada biaya tambahan berdasarkan rute atau durasi.',
    ],
  },
  {
    number: '03',
    title: 'Merencanakan perjalanan dari Depok ke bandara',
    paragraphs: [
      'Untuk perjalanan dari Depok menuju Bandara Soekarno-Hatta, pertimbangkan jadwal penerbangan, waktu check-in, kondisi lalu lintas, serta kebutuhan bagasi. Berikan informasi jadwal penerbangan dan alamat penjemputan ketika meminta penawaran.',
      'Konfirmasikan jenis kendaraan, waktu penjemputan, titik turun, harga akhir, dan ketentuan perubahan jadwal sebelum perjalanan. Untuk penjemputan dari bandara, sampaikan terminal serta informasi kedatangan agar detail perjalanan lebih mudah dikoordinasikan.',
    ],
  },
  {
    number: '04',
    title: 'Tips memilih kendaraan sesuai kebutuhan',
    paragraphs: [
      'City car dapat dipertimbangkan untuk mobilitas harian dengan jumlah penumpang terbatas. MPV seperti Avanza atau Innova bisa dipertimbangkan untuk perjalanan keluarga, sedangkan SUV dan van dapat menjadi pilihan untuk kebutuhan tertentu atau rombongan.',
      'Jangan hanya melihat harga awal. Bandingkan durasi penggunaan, kapasitas penumpang, jenis layanan, fasilitas yang termasuk, dan kemungkinan biaya tambahan. Harga pada katalog NAYVERA merupakan referensi yang tetap perlu dikonfirmasi sebelum booking.',
    ],
  },
  {
    number: '05',
    title: 'Dokumen dan persyaratan sewa mobil lepas kunci',
    paragraphs: [
      'Pada layanan lepas kunci, penyewa mengemudikan kendaraan sendiri sehingga biasanya diperlukan dokumen identitas dan surat izin mengemudi yang masih berlaku. Persyaratan lengkapnya dapat berbeda untuk setiap unit dan jenis layanan, jadi tanyakan terlebih dahulu kepada admin sebelum hari pemakaian.',
      'Selain dokumen, pahami juga ketentuan penggunaan kendaraan, batas waktu pengembalian, kondisi unit saat serah terima, serta tanggung jawab jika terjadi kerusakan atau keterlambatan. Pastikan semua ketentuan tersebut sudah jelas dan disepakati sebelum kamu mengonfirmasi booking.',
    ],
  },
  {
    number: '06',
    title: 'Avanza, Innova Reborn, atau Innova Zenix untuk perjalanan keluarga?',
    paragraphs: [
      'Avanza dapat dipertimbangkan untuk perjalanan keluarga dan aktivitas harian dengan kapasitas 6–7 penumpang. Innova Reborn menawarkan kabin yang lebih lega sehingga banyak dipilih untuk perjalanan antarkota dan agenda pekerjaan. Innova Zenix G dapat menjadi pilihan jika kamu mengutamakan kenyamanan dan kendaraan generasi yang lebih modern.',
      'Pilih berdasarkan jumlah penumpang, jumlah bagasi, jarak tempuh, dan anggaran. Karena harga katalog merupakan referensi, tanyakan ketersediaan unit pada tanggal yang kamu butuhkan serta tarif akhir sebelum menentukan pilihan.',
    ],
  },
  {
    number: '07',
    title: 'Sewa mobil untuk wisata keluarga dari Depok',
    paragraphs: [
      'Dari Depok, banyak tujuan wisata keluarga yang dapat dijangkau dengan kendaraan sewaan, misalnya kawasan Bogor dan Puncak, Bandung, atau destinasi lain di sekitar Jabodetabek. Tentukan terlebih dahulu jumlah peserta, jumlah barang bawaan, dan apakah ada anak kecil atau lansia agar kendaraan yang dipilih terasa nyaman.',
      'Untuk rute yang belum kamu kenal atau perjalanan yang cukup panjang, layanan dengan driver dapat membantu agar kamu lebih rileks. Tanyakan juga apakah biaya seperti bahan bakar, tol, parkir, dan biaya driver sudah termasuk dalam paket atau ditagih terpisah.',
    ],
  },
  {
    number: '08',
    title: 'Tips sewa mobil untuk pernikahan dan acara khusus',
    paragraphs: [
      'Untuk pernikahan, lamaran, atau acara keluarga besar, kebutuhan kendaraan sebaiknya direncanakan jauh hari karena tanggal acara cenderung ramai. Sampaikan tanggal, jam mulai, lokasi penjemputan, dan titik tujuan sejak awal agar admin dapat memeriksa ketersediaan unit.',
      'Pilih kendaraan sesuai kebutuhan, misalnya SUV atau MPV untuk keluarga inti dan van untuk rombongan. Jika kamu berencana memberi dekorasi pada kendaraan, tanyakan terlebih dahulu apakah diperbolehkan serta ketentuannya. Konfirmasikan juga jadwal pengembalian agar tidak mengganggu rangkaian acara.',
    ],
  },
  {
    number: '09',
    title: 'Sewa mobil untuk mahasiswa dan kegiatan kampus',
    paragraphs: [
      'Kawasan Margonda, UI, dan sekitarnya dipenuhi aktivitas kampus yang kadang membutuhkan kendaraan, seperti survei lapangan, kegiatan organisasi, kunjungan industri, atau mengantar keluarga saat wisuda. City car seperti Agya atau Ayla bisa dipertimbangkan untuk kebutuhan dengan jumlah orang sedikit.',
      'Untuk kegiatan kelompok, patungan menyewa MPV seperti Avanza atau Innova dapat menjadi pilihan yang lebih efisien. Sampaikan tanggal pemakaian, rute, dan jumlah peserta kepada admin, lalu pastikan persyaratan penyewa terpenuhi sebelum melakukan pemesanan.',
    ],
  },
];

export default function SewaMobilDepokPage() {
  return (
    <main className="min-h-screen overflow-hidden bg-white text-slate-900">
      <Navbar />

      {/* HERO */}
      <section className="relative isolate overflow-hidden bg-[#07111f] text-white">
        <div className="absolute inset-0 -z-10">
          <img
            src="/assets/images/AYLA DAN AGYA.jpg"
            alt="Armada sewa mobil Depok NAYVERA"
            fetchPriority="high"
            className="h-full w-full object-cover object-center opacity-35"
          />
          <div className="absolute inset-0 bg-gradient-to-r from-[#07111f] via-[#07111f]/90 to-[#07111f]/55" />
          <div className="absolute inset-0 bg-gradient-to-t from-[#07111f] via-transparent to-[#07111f]/20" />
        </div>

        <div className="relative mx-auto grid min-h-[680px] max-w-7xl items-center gap-10 px-5 py-16 sm:px-8 lg:grid-cols-[1.05fr_0.75fr] lg:gap-14 lg:px-12 lg:py-20">
          {/* KONTEN KIRI */}
          <div className="max-w-2xl">
            <div className="mb-6 inline-flex items-center gap-2 rounded-full border border-[#d4af37]/40 bg-[#d4af37]/10 px-4 py-2 text-sm font-medium text-[#e4c45a]">
              <MapPin size={16} />
              Rental Mobil Depok & Sekitarnya
            </div>

            <h1 className="text-4xl font-bold leading-tight tracking-tight sm:text-5xl lg:text-6xl">
              Sewa Mobil Depok
              <span className="mt-1 block text-[#d4af37]">
                Mulai dari 300 Ribuan
              </span>
            </h1>

            <p className="mt-6 max-w-xl text-base leading-8 text-slate-300 sm:text-lg">
              Rental mobil Depok untuk kebutuhan keluarga, kampus, bisnis,
              antar jemput bandara, hingga perjalanan luar kota. Tersedia
              pilihan lepas kunci maupun dengan driver sesuai kebutuhanmu.
            </p>

            <div className="mt-8 flex flex-col gap-3 sm:flex-row">
              <a
                href={createWhatsAppUrl()}
                target="_blank"
                rel="noopener noreferrer"
                className="inline-flex min-h-14 items-center justify-center gap-2 rounded-xl bg-[#d4af37] px-6 py-3.5 font-semibold text-[#07111f] transition hover:bg-[#e4c45a]"
              >
                <MessageCircle size={19} />
                Konsultasi & Booking
                <ArrowRight size={18} />
              </a>

              <a
                href="#armada"
                className="inline-flex min-h-14 items-center justify-center gap-2 rounded-xl border border-white/25 bg-white/5 px-6 py-3.5 font-semibold text-white backdrop-blur transition hover:border-[#d4af37]/60 hover:bg-white/10"
              >
                Lihat Armada
                <ArrowRight size={18} />
              </a>
            </div>

            <div className="mt-9 grid grid-cols-2 gap-4 sm:grid-cols-4">
              {[
                ['300 Ribuan', 'Harga referensi mulai'],
                ['Lepas Kunci', 'Pilihan layanan'],
                ['Dengan Driver', 'Unit tertentu'],
                ['Soekarno-Hatta', 'Airport transfer'],
              ].map(([value, label]) => (
                <div
                  key={label}
                  className="border-l border-[#d4af37]/50 pl-3"
                >
                  <div className="text-sm font-bold text-[#e4c45a] sm:text-base">
                    {value}
                  </div>
                  <div className="mt-1 text-xs leading-5 text-slate-400">
                    {label}
                  </div>
                </div>
              ))}
            </div>
          </div>

          {/* KARTU KANAN */}
          <div className="w-full max-w-xl justify-self-center lg:justify-self-end">
            <div className="rounded-3xl border border-white/10 bg-white/[0.06] p-7 shadow-2xl backdrop-blur">
              <div className="flex items-center gap-3">
                <div className="flex h-12 w-12 shrink-0 items-center justify-center rounded-2xl bg-[#d4af37]/15 text-[#e4c45a]">
                  <CarFront size={25} />
                </div>

                <div>
                  <h2 className="font-bold text-white">
                    Butuh kendaraan?
                  </h2>
                  <p className="text-sm text-slate-400">
                    Mulai dari kebutuhan perjalanan Anda
                  </p>
                </div>
              </div>

              <div className="mt-7 space-y-4">
                {[
                  'Tentukan tanggal dan durasi',
                  'Pilih kendaraan yang dibutuhkan',
                  'Sampaikan lokasi jemput dan tujuan',
                  'Konfirmasikan harga dan ketentuan',
                ].map((item) => (
                  <div key={item} className="flex items-center gap-3">
                    <CheckCircle2
                      size={19}
                      className="shrink-0 text-[#e4b63f]"
                    />
                    <span className="text-sm leading-6 text-slate-300">
                      {item}
                    </span>
                  </div>
                ))}
              </div>

              <a
                href={createWhatsAppUrl()}
                target="_blank"
                rel="noopener noreferrer"
                className="mt-8 inline-flex w-full items-center justify-center gap-2 rounded-xl bg-[#d4af37] px-5 py-3.5 font-bold text-[#07111f] transition hover:bg-[#e4c45a]"
              >
                <MessageCircle size={19} />
                Tanyakan Ketersediaan
              </a>
            </div>
          </div>
        </div>

      </section>

      {/* TRUST STRIP */}
      <section className="border-b border-slate-200 bg-white">
        <div className="mx-auto grid max-w-7xl grid-cols-2 px-5 sm:px-8 md:grid-cols-4 lg:px-12">
          {[
            {
              icon: CarFront,
              title: 'Pilihan Armada',
              text: 'Berbagai kategori kendaraan',
            },
            {
              icon: Users,
              title: 'Kebutuhan Beragam',
              text: 'Keluarga hingga bisnis',
            },
            {
              icon: Route,
              title: 'Pilihan Perjalanan',
              text: 'Dalam dan luar kota',
            },
            {
              icon: MessageCircle,
              title: 'Konsultasi WhatsApp',
              text: 'Konfirmasi sebelum booking',
            },
          ].map((item, index) => {
            const Icon = item.icon;

            return (
              <div
                key={item.title}
                className={`flex gap-3 border-slate-200 px-2 py-5 sm:px-4 sm:py-7 ${
                  index % 2 === 0 ? 'border-r md:border-r-0' : ''
                } ${index < 2 ? 'border-b md:border-b-0' : ''} ${
                  index !== 3 ? 'md:border-r' : ''
                }`}
              >
                <Icon
                  size={21}
                  className="mt-1 shrink-0 text-[#b89528]"
                  strokeWidth={1.7}
                />
                <div>
                  <h2 className="text-xs font-bold text-[#07111f] sm:text-sm">
                    {item.title}
                  </h2>
                  <p className="mt-1 text-[10px] leading-5 text-slate-500 sm:text-xs">
                    {item.text}
                  </p>
                </div>
              </div>
            );
          })}
        </div>
      </section>

      {/* INTRODUCTION */}
      <section className="bg-white py-20 sm:py-24">
        <div className="mx-auto grid max-w-7xl gap-10 px-5 sm:px-8 lg:grid-cols-[0.85fr_1.15fr] lg:gap-20 lg:px-12">
          <div>
            <p className="text-xs font-bold uppercase tracking-[0.2em] text-[#b89528]">
              Rental Mobil Depok
            </p>

            <h2 className="mt-4 text-3xl font-bold leading-tight text-[#07111f] sm:text-5xl">
              Mobilitas Depok, dengan standar layanan NAYVERA.
            </h2>
          </div>

          <div>
            <p className="text-base leading-8 text-slate-600">
              NAYVERA INDO TRANSPORT menyediakan layanan sewa mobil Depok
              untuk membantu kebutuhan perjalanan sehari-hari, kegiatan
              keluarga, aktivitas profesional, dan perjalanan antarkota.
            </p>

            <p className="mt-5 text-base leading-8 text-slate-600">
              Kamu bisa mengonsultasikan jenis kendaraan, durasi, lokasi
              penjemputan, dan tujuan perjalanan sebelum menentukan paket.
              Dengan begitu, pilihan layanan dapat disesuaikan dengan
              kebutuhan perjalananmu.
            </p>

            <div className="mt-8 grid gap-4 border-t border-slate-200 pt-6 sm:grid-cols-2">
              <div className="flex gap-3">
                <CheckCircle2
                  size={20}
                  className="mt-0.5 shrink-0 text-[#b89528]"
                />
                <div>
                  <p className="font-semibold text-[#07111f]">
                    Pilihan layanan
                  </p>
                  <p className="mt-1 text-sm leading-6 text-slate-500">
                    Lepas kunci maupun dengan driver.
                  </p>
                </div>
              </div>

              <div className="flex gap-3">
                <CheckCircle2
                  size={20}
                  className="mt-0.5 shrink-0 text-[#b89528]"
                />
                <div>
                  <p className="font-semibold text-[#07111f]">
                    Sesuai kebutuhan
                  </p>
                  <p className="mt-1 text-sm leading-6 text-slate-500">
                    Pilihan kendaraan berdasarkan perjalanan.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* SERVICES */}
      <section className="bg-[#07111f] py-20 text-white sm:py-24">
        <div className="mx-auto max-w-7xl px-5 sm:px-8 lg:px-12">
          <div className="grid gap-6 md:grid-cols-[1fr_0.7fr] md:items-end">
            <div>
              <p className="text-xs font-bold uppercase tracking-[0.2em] text-[#e4c45a]">
                Solusi Perjalanan
              </p>
              <h2 className="mt-4 max-w-3xl text-3xl font-bold leading-tight sm:text-5xl">
                Satu layanan transportasi, berbagai kebutuhan.
              </h2>
            </div>

            <p className="max-w-lg text-sm leading-7 text-slate-400">
              Tentukan tujuan perjalanan terlebih dahulu. Tim NAYVERA dapat
              membantu menjelaskan pilihan kendaraan dan layanan yang tersedia.
            </p>
          </div>

          <div className="mt-12 grid gap-0 border-t border-white/15 sm:grid-cols-2">
            {services.map((service) => {
              const Icon = service.icon;

              return (
                <article
                  key={service.number}
                  className="group border-b border-white/15 py-7 sm:px-6 sm:py-9 first:sm:pl-0 even:sm:pr-0 sm:odd:border-r sm:odd:pr-8 sm:even:pl-8"
                >
                  <div className="flex items-start justify-between gap-5">
                    <div className="flex h-12 w-12 items-center justify-center border border-[#d4af37]/40 bg-[#d4af37]/10 text-[#e4c45a] transition group-hover:bg-[#d4af37] group-hover:text-[#07111f]">
                      <Icon size={23} />
                    </div>
                    <span className="text-xs tracking-[0.16em] text-[#e4c45a]">
                      / {service.number}
                    </span>
                  </div>

                  <h3 className="mt-6 text-xl font-bold sm:text-2xl">
                    {service.title}
                  </h3>

                  <p className="mt-3 max-w-lg text-sm leading-7 text-slate-400">
                    {service.description}
                  </p>

                  <a
                    href={createWhatsAppUrl('', service.title)}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="mt-6 inline-flex items-center gap-2 text-sm font-semibold text-[#e4c45a] transition hover:text-white"
                  >
                    Konsultasikan layanan
                    <ArrowRight size={16} />
                  </a>
                </article>
              );
            })}
          </div>
        </div>
      </section>

      {/* FLEET */}
      <section id="armada" className="bg-[#f7f7f5] py-20 sm:py-24">
        <div className="mx-auto max-w-7xl px-5 sm:px-8 lg:px-12">
          <div className="flex flex-col gap-6 lg:flex-row lg:items-end lg:justify-between">
            <div className="max-w-3xl">
              <p className="text-xs font-bold uppercase tracking-[0.2em] text-[#b89528]">
                Armada NAYVERA
              </p>
              <h2 className="mt-4 text-3xl font-bold leading-tight text-[#07111f] sm:text-5xl">
                Pilihan rental mobil Depok untuk perjalananmu.
              </h2>
              <p className="mt-5 max-w-2xl text-sm leading-7 text-slate-600 sm:text-base">
                Kenali kategori kendaraan, kapasitas, harga referensi, dan
                pilihan layanannya. Ketersediaan unit serta harga akhir dapat
                dikonfirmasi melalui WhatsApp.
              </p>
            </div>

            <a
              href="/fleet-armada-page"
              className="inline-flex items-center gap-2 self-start bg-[#07111f] px-5 py-3.5 text-sm font-semibold text-white transition hover:bg-[#132b45] lg:self-auto"
            >
              Lihat Armada Lengkap
              <ArrowUpRight size={17} />
            </a>
          </div>

          <div className="mt-12 grid gap-x-6 gap-y-10 sm:grid-cols-2 lg:grid-cols-3">
            {fleet.map((car) => (
              <article
                key={car.name}
                className="group flex flex-col overflow-hidden rounded-2xl border border-slate-200 bg-white shadow-sm transition duration-300 hover:-translate-y-1 hover:border-[#d4af37]/70 hover:shadow-xl"
              >
                {/* FOTO + BADGE */}
                <div className="relative h-[240px] overflow-hidden bg-slate-100 sm:h-[250px]">
                  <img
                    src={car.image}
                    alt={`${car.name} untuk rental mobil Depok NAYVERA`}
                    loading="lazy"
                    className="h-full w-full object-cover transition duration-500 group-hover:scale-[1.04]"
                  />

                  <div className="absolute inset-x-0 bottom-0 h-24 bg-gradient-to-t from-black/60 to-transparent" />

                  <span className="absolute left-4 top-4 rounded-full bg-emerald-600 px-3 py-1 text-xs font-semibold text-white shadow">
                    Tersedia
                  </span>

                  {car.badge && (
                    <span className="absolute right-4 top-4 rounded-full bg-gradient-to-r from-[#e4c45a] to-[#c9a227] px-3 py-1 text-xs font-bold text-[#07111f] shadow">
                      {car.badge}
                    </span>
                  )}

                  <span className="absolute bottom-4 left-4 inline-flex items-center gap-1.5 rounded-full bg-black/55 px-3 py-1.5 text-xs font-medium text-white backdrop-blur">
                    <Users size={14} />
                    {car.capacity}
                  </span>
                </div>

                {/* ISI KARTU */}
                <div className="flex flex-1 flex-col p-5">
                  <p className="text-[11px] font-bold uppercase tracking-[0.14em] text-[#b89528]">
                    {car.category}
                  </p>
                  <h3 className="mt-1.5 text-lg font-bold leading-snug text-[#07111f]">
                    {car.name}
                  </h3>

                  {/* CHIP SPESIFIKASI */}
                  <div className="mt-4 grid grid-cols-2 gap-2">
                    <div className="flex items-center gap-2 rounded-xl bg-[#f1eee8] px-3 py-2.5 text-sm text-slate-600">
                      <Settings2 size={15} className="shrink-0 text-slate-500" />
                      <span className="truncate">{car.transmission}</span>
                    </div>
                    <div className="flex items-center gap-2 rounded-xl bg-[#f1eee8] px-3 py-2.5 text-sm text-slate-600">
                      <Fuel size={15} className="shrink-0 text-slate-500" />
                      <span className="truncate">{car.fuel}</span>
                    </div>
                  </div>

                  {/* TAG FITUR */}
                  <div className="mt-3 flex flex-wrap gap-2">
                    {car.features.slice(0, 3).map((feature) => (
                      <span
                        key={feature}
                        className="inline-flex items-center gap-1.5 rounded-full bg-[#f1eee8] px-3 py-1.5 text-xs text-slate-600"
                      >
                        <Star size={12} className="text-slate-500" />
                        {feature}
                      </span>
                    ))}
                    {car.features.length > 3 && (
                      <span className="inline-flex items-center px-1 py-1.5 text-xs text-slate-500">
                        +{car.features.length - 3} lagi
                      </span>
                    )}
                  </div>

                  <div className="mt-auto border-t border-slate-200 pt-4">
                    <div className="mt-1 flex items-end justify-between gap-3">
                      {/* HARGA */}
                      <div>
                        <p className="text-xs text-slate-500">Mulai dari</p>
                        <p className="mt-0.5 text-xl font-bold text-[#07111f]">
                          {car.price}
                        </p>
                        <p className="mt-0.5 text-xs text-slate-500">
                          {car.duration} · {car.service.toLowerCase()}
                        </p>
                      </div>

                      {/* TOMBOL */}
                      <div className="flex w-[118px] shrink-0 flex-col gap-2">
                        <a
                          href={createWhatsAppUrl(car.name, car.service)}
                          target="_blank"
                          rel="noopener noreferrer"
                          className="rounded-xl bg-gradient-to-r from-[#e4c45a] to-[#c9a227] px-3 py-2.5 text-center text-sm font-bold text-[#07111f] transition hover:brightness-105"
                        >
                          Booking
                        </a>
                        <a
                          href={`https://wa.me/${WA_NUMBER}?text=${encodeURIComponent(
                            `Halo NAYVERA, saya ingin bertanya tentang ${car.name}.`
                          )}`}
                          target="_blank"
                          rel="noopener noreferrer"
                          className="rounded-xl border border-emerald-500/60 bg-emerald-50 px-3 py-2.5 text-center text-sm font-semibold text-emerald-700 transition hover:bg-emerald-100"
                        >
                          WhatsApp
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
              </article>
            ))}
          </div>

          <p className="mt-6 text-xs leading-6 text-slate-500">
            Harga merupakan referensi dari data halaman sebelumnya.
            Konfirmasikan kembali tarif, paket, fasilitas, persyaratan, dan
            biaya tambahan kepada admin sebelum melakukan pemesanan.
          </p>
        </div>
      </section>

      {/* AIRPORT TRANSFER */}
      <section className="bg-white py-20 sm:py-24">
        <div className="mx-auto grid max-w-7xl gap-10 px-5 sm:px-8 lg:grid-cols-2 lg:items-center lg:gap-16 lg:px-12">
          <div className="relative">
            <img
              src="/assets/images/sewa mobil jakarta.jpeg"
              alt="Kendaraan untuk perjalanan dari Depok menuju Bandara Soekarno-Hatta"
              loading="lazy"
              className="h-[300px] w-full object-cover sm:h-[430px]"
            />
            <div className="absolute bottom-5 left-5 bg-[#07111f] px-5 py-4 text-white sm:bottom-7 sm:left-7">
              <p className="text-[10px] font-bold uppercase tracking-[0.16em] text-[#e4c45a]">
                Airport Transfer
              </p>
              <p className="mt-1 font-semibold">Depok ↔ Soekarno-Hatta</p>
            </div>
          </div>

          <div>
            <p className="text-xs font-bold uppercase tracking-[0.2em] text-[#b89528]">
              Perjalanan Bandara
            </p>
            <h2 className="mt-4 text-3xl font-bold leading-tight text-[#07111f] sm:text-5xl">
              Rencanakan perjalanan bandara dari Depok.
            </h2>

            <p className="mt-6 text-base leading-8 text-slate-600">
              Butuh kendaraan menuju atau dari Bandara Soekarno-Hatta?
              Konsultasikan jadwal penerbangan, titik penjemputan, jumlah
              penumpang, serta kebutuhan bagasi agar layanan yang dipilih
              sesuai dengan perjalananmu.
            </p>

            <div className="mt-7 space-y-4">
              {[
                'Konsultasi rute dan jadwal penjemputan',
                'Pilihan kendaraan sesuai kebutuhan',
                'Konfirmasi harga dan ketentuan sebelum booking',
              ].map((item) => (
                <div key={item} className="flex items-start gap-3">
                  <CheckCircle2
                    size={19}
                    className="mt-0.5 shrink-0 text-[#b89528]"
                  />
                  <span className="text-sm leading-6 text-slate-600">
                    {item}
                  </span>
                </div>
              ))}
            </div>

            <a
              href={createWhatsAppUrl('', 'Airport Transfer')}
              target="_blank"
              rel="noopener noreferrer"
              className="mt-8 inline-flex items-center gap-2 bg-[#d4af37] px-6 py-4 text-sm font-bold text-[#07111f] transition hover:bg-[#e4c45a]"
            >
              <Plane size={18} />
              Konsultasi Airport Transfer
              <ArrowRight size={17} />
            </a>
          </div>
        </div>
      </section>

      {/* SERVICE AREAS */}
      <section className="bg-[#07111f] py-20 text-white sm:py-24">
        <div className="mx-auto max-w-7xl px-5 sm:px-8 lg:px-12">
          <div className="grid gap-8 lg:grid-cols-[0.8fr_1.2fr] lg:gap-16">
            <div>
              <p className="text-xs font-bold uppercase tracking-[0.2em] text-[#e4c45a]">
                Area Layanan
              </p>
              <h2 className="mt-4 text-3xl font-bold leading-tight sm:text-5xl">
                Layanan sewa mobil Depok dan sekitarnya.
              </h2>
              <p className="mt-5 text-sm leading-7 text-slate-400">
                Titik penjemputan, tujuan, dan jangkauan layanan dapat
                dikonsultasikan terlebih dahulu kepada admin NAYVERA.
              </p>

              <a
                href={createWhatsAppUrl()}
                target="_blank"
                rel="noopener noreferrer"
                className="mt-7 inline-flex items-center gap-2 border-b border-[#d4af37] pb-2 text-sm font-semibold text-[#e4c45a] transition hover:text-white"
              >
                Konfirmasi area layanan
                <ArrowRight size={16} />
              </a>
            </div>

            <div className="grid grid-cols-2 gap-px border border-white/10 bg-white/10 sm:grid-cols-3">
              {areas.map((area, index) => (
                <div
                  key={area}
                  className="bg-[#0b192a] p-4 transition hover:bg-[#132b45] sm:p-5"
                >
                  <p className="text-[10px] tracking-[0.14em] text-[#e4c45a]">
                    {(index + 1).toString().padStart(2, '0')}
                  </p>
                  <p className="mt-3 text-sm font-semibold">{area}</p>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>

      {/* SEO ARTICLES */}
      <section className="bg-[#f7f7f5] py-20 sm:py-24">
        <div className="mx-auto max-w-7xl px-5 sm:px-8 lg:px-12">
          <div className="max-w-3xl">
            <p className="text-xs font-bold uppercase tracking-[0.2em] text-[#b89528]">
              Panduan Perjalanan
            </p>
            <h2 className="mt-4 text-3xl font-bold leading-tight text-[#07111f] sm:text-5xl">
              Informasi sebelum menyewa mobil di Depok.
            </h2>
            <p className="mt-5 text-sm leading-7 text-slate-600 sm:text-base">
              Beberapa hal yang dapat kamu pertimbangkan untuk memilih
              kendaraan, memahami pilihan layanan, dan merencanakan perjalanan.
            </p>
          </div>

          <div className="mt-10 grid gap-6 md:grid-cols-2">
            {articles.map((article) => (
              <article
                key={article.number}
                className="border border-slate-200 bg-white p-6 sm:p-8"
              >
                <p className="text-xs font-bold tracking-[0.16em] text-[#b89528]">
                  PANDUAN {article.number}
                </p>
                <h3 className="mt-4 text-xl font-bold leading-snug text-[#07111f] sm:text-2xl">
                  {article.title}
                </h3>

                {article.paragraphs.map((paragraph) => (
                  <p
                    key={paragraph}
                    className="mt-4 text-sm leading-7 text-slate-600"
                  >
                    {paragraph}
                  </p>
                ))}

                <a
                  href={createWhatsAppUrl('', article.title)}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="mt-6 inline-flex items-center gap-2 text-sm font-semibold text-[#8a6b18] transition hover:text-[#07111f]"
                >
                  Konsultasikan kebutuhanmu
                  <ArrowRight size={16} />
                </a>
              </article>
            ))}
          </div>
        </div>
      </section>

      {/* WHY NAYVERA */}
      <section className="bg-white py-20 sm:py-24">
        <div className="mx-auto max-w-7xl px-5 sm:px-8 lg:px-12">
          <div className="max-w-3xl">
            <p className="text-xs font-bold uppercase tracking-[0.2em] text-[#b89528]">
              Mengapa NAYVERA
            </p>
            <h2 className="mt-4 text-3xl font-bold leading-tight text-[#07111f] sm:text-5xl">
              Layanan yang dimulai dari kebutuhanmu.
            </h2>
          </div>

          <div className="mt-10 grid gap-5 sm:grid-cols-2 lg:grid-cols-4">
            {[
              {
                icon: ShieldCheck,
                title: 'Pilihan yang Jelas',
                text: 'Konsultasikan jenis kendaraan dan layanan sebelum memesan.',
              },
              {
                icon: Clock3,
                title: 'Perencanaan Perjalanan',
                text: 'Sampaikan tanggal dan durasi agar ketersediaan dapat diperiksa.',
              },
              {
                icon: MapPin,
                title: 'Kebutuhan Rute',
                text: 'Tentukan titik jemput serta tujuan untuk mendapatkan informasi yang sesuai.',
              },
              {
                icon: MessageCircle,
                title: 'Konsultasi Langsung',
                text: 'Tanyakan harga, paket, persyaratan, dan ketentuan melalui WhatsApp.',
              },
            ].map((item) => {
              const Icon = item.icon;

              return (
                <article
                  key={item.title}
                  className="border border-slate-200 p-6 transition hover:border-[#d4af37]/70 hover:shadow-lg"
                >
                  <div className="flex h-12 w-12 items-center justify-center bg-[#07111f] text-[#e4c45a]">
                    <Icon size={22} />
                  </div>
                  <h3 className="mt-5 text-lg font-bold text-[#07111f]">
                    {item.title}
                  </h3>
                  <p className="mt-3 text-sm leading-7 text-slate-600">
                    {item.text}
                  </p>
                </article>
              );
            })}
          </div>
        </div>
      </section>

      {/* BOOKING PROCESS */}
      <section className="bg-slate-50 py-20 sm:py-24">
        <div className="mx-auto max-w-7xl px-5 sm:px-8 lg:px-12">
          <div className="text-center">
            <p className="text-xs font-bold uppercase tracking-[0.2em] text-[#b89528]">
              Cara Pemesanan
            </p>
            <h2 className="mt-4 text-3xl font-bold text-[#07111f] sm:text-5xl">
              Booking dengan langkah yang jelas.
            </h2>
          </div>

          <div className="mt-12 grid gap-5 md:grid-cols-3">
            {[
              {
                number: '01',
                title: 'Kirim kebutuhan',
                description:
                  'Sampaikan kendaraan, tanggal, durasi, lokasi penjemputan, tujuan, dan jumlah penumpang.',
              },
              {
                number: '02',
                title: 'Konsultasikan paket',
                description:
                  'Tanyakan ketersediaan unit, jenis layanan, harga, fasilitas, dan persyaratan.',
              },
              {
                number: '03',
                title: 'Konfirmasi booking',
                description:
                  'Pastikan seluruh detail dan biaya akhir sudah disepakati sebelum pemesanan.',
              },
            ].map((step) => (
              <article
                key={step.number}
                className="border border-slate-200 bg-white p-7 sm:p-8"
              >
                <p className="text-4xl font-bold tracking-tight text-[#d4af37]">
                  {step.number}
                </p>
                <h3 className="mt-5 text-xl font-bold text-[#07111f]">
                  {step.title}
                </h3>
                <p className="mt-3 text-sm leading-7 text-slate-600">
                  {step.description}
                </p>
              </article>
            ))}
          </div>

          <div className="mt-9 text-center">
            <a
              href={createWhatsAppUrl()}
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center gap-2 bg-[#07111f] px-7 py-4 text-sm font-bold text-white transition hover:bg-[#132b45]"
            >
              <MessageCircle size={18} />
              Mulai Konsultasi WhatsApp
              <ArrowRight size={17} />
            </a>
          </div>
        </div>
      </section>

      {/* FAQ */}
      <section className="bg-white py-20 sm:py-24">
        <div className="mx-auto grid max-w-7xl gap-10 px-5 sm:px-8 lg:grid-cols-[0.75fr_1.25fr] lg:gap-16 lg:px-12">
          <div>
            <p className="text-xs font-bold uppercase tracking-[0.2em] text-[#b89528]">
              FAQ
            </p>
            <h2 className="mt-4 text-3xl font-bold leading-tight text-[#07111f] sm:text-5xl">
              Pertanyaan seputar sewa mobil Depok.
            </h2>
            <p className="mt-5 text-sm leading-7 text-slate-600">
              Temukan informasi dasar sebelum menentukan kendaraan dan
              menghubungi admin.
            </p>
          </div>

          <div className="border-t border-slate-200">
            {faqs.map((faq) => (
              <details
                key={faq.question}
                className="group border-b border-slate-200"
              >
                <summary className="flex cursor-pointer list-none items-center justify-between gap-5 py-5 text-sm font-semibold text-[#07111f] sm:py-6 sm:text-base">
                  <span>{faq.question}</span>
                  <ChevronDown
                    size={19}
                    className="shrink-0 text-[#b89528] transition group-open:rotate-180"
                  />
                </summary>

                <p className="max-w-3xl pb-6 pr-5 text-sm leading-7 text-slate-600">
                  {faq.answer}
                </p>
              </details>
            ))}
          </div>
        </div>
      </section>

      {/* FINAL CTA */}
      <section className="bg-[#07111f] py-20 text-white sm:py-24">
        <div className="mx-auto max-w-7xl px-5 sm:px-8 lg:px-12">
          <div className="relative overflow-hidden border border-[#d4af37]/35 px-6 py-12 sm:px-10 sm:py-16 lg:px-14">
            <div className="absolute -right-20 -top-20 h-64 w-64 rounded-full bg-[#d4af37]/10 blur-3xl" />
            <div className="relative grid gap-8 lg:grid-cols-[1fr_auto] lg:items-end">
              <div>
                <p className="text-xs font-bold uppercase tracking-[0.2em] text-[#e4c45a]">
                  NAYVERA INDO TRANSPORT
                </p>
                <h2 className="mt-5 max-w-3xl text-3xl font-bold leading-tight sm:text-5xl">
                  Siap merencanakan perjalanan dari Depok?
                </h2>
                <p className="mt-5 max-w-2xl text-sm leading-7 text-slate-300 sm:text-base">
                  Ceritakan kebutuhan kendaraanmu kepada tim NAYVERA. Tanyakan
                  ketersediaan, harga, pilihan layanan, dan ketentuan sebelum
                  melakukan pemesanan.
                </p>
              </div>

              <a
                href={createWhatsAppUrl()}
                target="_blank"
                rel="noopener noreferrer"
                className="inline-flex min-h-14 items-center justify-center gap-2 bg-[#d4af37] px-6 py-4 text-sm font-bold text-[#07111f] transition hover:bg-[#e4c45a]"
              >
                <MessageCircle size={18} />
                Hubungi NAYVERA
                <ArrowUpRight size={17} />
              </a>
            </div>
          </div>
        </div>
      </section>

      <Footer />
      <WhatsAppFloat />
    </main>
  );
}
